import { render, staticRenderFns } from "./EmailBuilderDemo.vue?vue&type=template&id=a48f7d22&scoped=true&"
import script from "./EmailBuilderDemo.vue?vue&type=script&lang=js&"
export * from "./EmailBuilderDemo.vue?vue&type=script&lang=js&"
import style0 from "./EmailBuilderDemo.vue?vue&type=style&index=0&id=a48f7d22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48f7d22",
  null
  
)

export default component.exports